import { render, staticRenderFns } from "./BaseShortcutLink.vue?vue&type=template&id=e11f1a64&scoped=true&"
import script from "./BaseShortcutLink.vue?vue&type=script&lang=js&"
export * from "./BaseShortcutLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseShortcutLink.vue?vue&type=style&index=0&id=e11f1a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11f1a64",
  null
  
)

export default component.exports